<template>
  <div id="app">
    <div class="go-back" v-if="$route.meta.back">
      <img @click="goBack()" src="./resource/img/goback.png">
    </div>
    <transition :name="transitionName" mode="out-in">
      <keep-alive v-if="$route.meta.keepAlive">
        <!-- 需要缓存的视图组件 -->
        <router-view class="view" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不需要缓存的视图组件 -->
      <router-view class="view" v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-fade',
      pageData: 1,
      title: '活动订单'
    }
  },
  watch: {
    '$route' (to) {
      //设置tab页面和普通页面的过度动画效果
      this.transitionName = to.meta.tab ? 'fade' : 'slide-fade'
    }
  },
  methods: {
    /**
     * 返回上一层
     */
    goBack: function () {
      let pageData = this.pageData
      if (pageData == 1) {
        this.$router.go(-1)
      }
      if (pageData == 2) {
        this.$router.go(-2)
      }
    }
  }
}
</script>

<style>
  body {
    margin: 0;
    padding: 0;
    /*background-color:#000;*/
  }

  /*去掉<router-link>的默认样式*/
  a {
    text-decoration: none;
    color: #000;
  }

  .go-back {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 50px;
    background-color: #32353C;
    position: absolute;
    top: 0;
  }

  .go-back img {
    margin-left: 15px;
    width: 15px;
    height: 25px;
  }


  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .1s ease;
  }

  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.4, 0.7, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateX(5px);
    opacity: 0;
  }

  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/

  }

  .view {
    font-family: PingFangSC-Regular, Helvetica Neue, Microsoft JhengHei, Helvetica, Arial, Microsoft Yahei, Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, sans-serif;
    background-color: #F5F6F8;
    width: 100vw;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue